import CreateNotifications from '../Notifications';

const key = 'authToken';

const storeToken = async (authToken) => {
  try {
    localStorage.setItem(key, JSON.stringify(authToken));
  } catch (error) {
    CreateNotifications('error', 'Something went wrong');
  }
};

const getToken = async () => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    console.log('====================================');
    CreateNotifications('error', 'Cannot find the token. Please login again');
    console.log('====================================');
  }
};

const removeToken = async () => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.log('====================================');
    CreateNotifications('error', 'Something went wrong please Refresh.');
    console.log('====================================');
  }
};

// eslint-disable-next-line
export default {
  getToken,
  storeToken,
  removeToken,
};
